(() => {
  const DESKTOP = window.matchMedia("(min-width: 990px)");

  function initHoverMenu() {
    const header = document.querySelector(".section-header");
    if (!header) return;

    const inlineMenu = header.querySelector(".header__inline-menu");
    if (!inlineMenu) return;

    // Top-level dropdown <details> only (the ones that wrap each main nav item)
    const topDetails = Array.from(
      inlineMenu.querySelectorAll(':scope > ul > li > header-menu > details')
    );

    if (!topDetails.length) return;

    let closeTimer = null;

    const closeAll = (except = null) => {
      topDetails.forEach((d) => {
        if (d !== except) d.removeAttribute("open");
      });
    };

    const closeNested = (rootDetails) => {
      // Close any nested details inside the dropdown so next hover starts clean
      rootDetails.querySelectorAll("details[open]").forEach((d) => d.removeAttribute("open"));
    };

    topDetails.forEach((d) => {
      d.addEventListener("mouseenter", () => {
        if (!DESKTOP.matches) return;

        if (closeTimer) clearTimeout(closeTimer);

        closeAll(d);
        d.setAttribute("open", "");
      });

      d.addEventListener("mouseleave", () => {
        if (!DESKTOP.matches) return;

        if (closeTimer) clearTimeout(closeTimer);

        closeTimer = setTimeout(() => {
          closeNested(d);
          d.removeAttribute("open");
        }, 140);
      });

      // If the user tabs away, close
      d.addEventListener("focusout", (e) => {
        if (!DESKTOP.matches) return;
        if (!d.contains(e.relatedTarget)) {
          closeNested(d);
          d.removeAttribute("open");
        }
      });
    });

    // Close if user clicks elsewhere
    document.addEventListener("click", (e) => {
      if (!DESKTOP.matches) return;
      if (!header.contains(e.target)) closeAll();
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initHoverMenu);
  } else {
    initHoverMenu();
  }
})();
